import { useRef } from 'react';
import { CalendarDays } from 'lucide-react';

// Shared by every dated export control on the Manager Exports tab — the
// Fill/accounting range and both Google Sheets panels. Lives on its own so a
// panel module never has to import a sibling panel module for it.

function openDatePicker(input: HTMLInputElement | null): void {
  if (!input) return;
  const maybePicker = input as HTMLInputElement & { showPicker?: () => void };
  if (typeof maybePicker.showPicker === 'function') {
    try {
      maybePicker.showPicker();
      return;
    } catch {
      /* showPicker can throw when the input is disabled or not visible. */
    }
  }
  input.focus();
}

function ExportDateInput({
  id,
  label,
  value,
  onChange,
  disabled,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <label className="min-w-[8.5rem] flex-1">
      <span className="text-muted-foreground mb-1 block text-[11px] font-medium">{label}</span>
      <span className="relative block">
        <button
          type="button"
          onClick={() => openDatePicker(inputRef.current)}
          disabled={disabled}
          title={`Open ${label.toLowerCase()} calendar`}
          className="text-muted-foreground hover:text-foreground absolute left-1.5 top-1/2 -translate-y-1/2 rounded p-0.5 disabled:opacity-50"
        >
          <CalendarDays size={14} />
        </button>
        <input
          ref={inputRef}
          id={id}
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="bg-background border-border text-foreground w-full rounded-md border py-1.5 pl-8 pr-2 text-xs focus:border-blue-500 focus:outline-none disabled:opacity-50 [&::-webkit-calendar-picker-indicator]:hidden"
        />
      </span>
    </label>
  );
}

export { ExportDateInput };
